import React from 'react';
import { FavoriteButtonContainer } from '../../favorites/favorite_button_container';

export function CSPFeedCallout() {
  return (
    <div className="bd-primary align-center"
      data-feed-callout
    >
      <FavoriteButtonContainer
        displayStyle="banner"
      />
    </div>
  );
}
